import React, { FC } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClipboardList, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons'

/* ----------  ONE combined card  ---------- */
interface Props {
  openOrders: number   // # open POs
  openValue:  number   // $ value of those POs
}

const TotalOpenOrdersCard: FC<Props> = ({ openOrders, openValue }) => (
  <div
    className='card d-flex flex-column h-auto'
    style={{ background: 'linear-gradient(45deg,#4E46A1,#E77A7A)' }}
  >
    <div className='p-4'>
      <header style={{ fontSize: '2.5rem' }}>
        {/* stack the two icons for a quick visual cue */}
        <FontAwesomeIcon icon={faClipboardList} className='me-2' />
        <FontAwesomeIcon icon={faFileInvoiceDollar} />
      </header>

      <div className='pt-3 pb-3 d-flex flex-column'>
        <div
          className='fw-bolder'
          style={{ fontSize: '3.5rem', lineHeight: 1 }}
        >
          {openOrders.toLocaleString()}
        </div>
        <div className='pt-2 fw-bold' style={{ fontSize: '1.15rem' }}>
          Open Orders #
        </div>
      </div>
    </div>

    <div
      style={{
        height: 1,
        width: 'auto',
        margin: '0 50% 0 5%',
        background: 'rgba(255,255,255,0.4)',
      }}
    />

    <footer className='h-auto rounded-bottom pt-3 pb-3 px-4'>
      <div className='d-flex flex-column'>
        <div className='fs-1 fw-bold'>
          ${openValue.toLocaleString()}
        </div>
        <div className='text-body-secondary fw-bold'>
          Open Orders $
        </div>
      </div>
    </footer>
  </div>
)

export { TotalOpenOrdersCard }